export default {
    computed: {
    },
    watch: {},
    methods: {
        getDateUnixTime(dateStr) {
            let [yr, mth, day] = dateStr.split('-')
            yr = parseInt(yr)
            mth = parseInt(mth) - 1
            day = parseInt(day)
            return new Date(yr, mth, day).getTime()
        },

        addDays(unixTime, days) {
            return unixTime + days * 24 * 60 * 60 * 1000
        },

        getDateFromUnixTime(unixTime) {
            const dt = new Date(unixTime)
            return `${dt.getFullYear()}-${this.twoDigitsFormat(
                dt.getMonth() + 1
            )}-${this.twoDigitsFormat(dt.getDate())}`
        },

        getName(user) {
            return user && user.first_name + ' ' + user.last_name
        },

        twoDigitsFormat(x) {
            x = parseInt(x) || 0
            return ("0" + x).slice(-2)
        },

        onlyUnique(value, index, array) {
            return array.indexOf(value) === index;
        },


        getAssetSchedulerData(assets) {
            return assets.flatMap(
                ({
                    id,
                    next_service_date,
                    contract_expiry_date,
                    frequency,
                    name,
                    default_engineer,
                    customer,
                    type_id,
                    type,
                }) => {

                    if (!next_service_date || !contract_expiry_date) return []
                    const next_service_ut =
                        this.getDateUnixTime(next_service_date)
                    const expiry_date_ut =
                        this.getDateUnixTime(contract_expiry_date)

                    const current_date_ut = Date.now()
                    const ServiceDates = [] // Declare the variable outside the if block

                    let new_service_date_ut = next_service_ut;
                    while (expiry_date_ut > current_date_ut && new_service_date_ut < expiry_date_ut) {
                        ServiceDates.push(new_service_date_ut)
                        new_service_date_ut = this.addDays(
                            new_service_date_ut,
                            frequency
                        )
                    }

                    ServiceDates.sort((a, b) => a - b)
                    const { onlyUnique } = this;

                    return ServiceDates.filter(onlyUnique).map((newDate) => ({
                        title: name,
                        start: this.getDateFromUnixTime(newDate),
                        customerName: customer && customer.name,
                        agentName: this.getName(default_engineer),
                        type_id,
                        typeName: type.name,
                        nextDate: this.getDateFromUnixTime(newDate),
                        eventId: id,
                    }))
                }
            )
        },
    },
}
